import type { Joker, JokerEffect } from '../../engine/types'
import { CARD_SIZES } from '../components'
import { JokerCard } from './JokerCard'

type Props = {
  jokers: Joker[]
  maxJokers: number
  activeJokerId?: string | null
  effects?: JokerEffect[]
}

export function JokerRow({ jokers, maxJokers, activeJokerId, effects = [] }: Props) {
  return (
    <div
      className="flex items-center gap-3 px-4 py-3 mx-4 mt-3 rounded-lg overflow-x-auto"
      style={{
        background: 'rgba(0,0,0,0.3)',
        border: '1px solid rgba(160,120,200,0.15)',
      }}
    >
      <div className="text-[11px] uppercase tracking-wider shrink-0 font-semibold" style={{ color: 'rgba(200,170,230,0.45)' }}>
        Joker
      </div>

      {jokers.map((joker) => {
        const isActive = activeJokerId === joker.id
        const effect = effects.find(e => e.jokerId === joker.id)

        return (
          <div key={joker.id} className="shrink-0">
            <JokerCard
              joker={joker}
              size="sm"
              isActive={isActive}
              effect={effect}
            />
          </div>
        )
      })}

      {/* Empty slots */}
      {Array.from({ length: Math.max(0, maxJokers - jokers.length) }).map((_, i) => (
        <div
          key={`empty-${i}`}
          className="shrink-0 rounded-[10px] border-2 border-dashed opacity-20"
          style={{ width: CARD_SIZES.sm.width, height: CARD_SIZES.sm.height, borderColor: 'rgba(160,120,200,0.3)' }}
        />
      ))}

      {/* Counter */}
      <div className="ml-auto text-[11px] font-mono shrink-0" style={{ color: 'rgba(200,170,230,0.35)' }}>
        {jokers.length}/{maxJokers}
      </div>
    </div>
  )
}
